export const UpdateTypes = {
	CHECK_FOR_UPDATE: 'CHECK_FOR_UPDATE',
	UPDATE_AVAILABLE: 'UPDATE_AVAILABLE'
}